import React from "react";
import { Button } from "@windmill/react-ui";

const VendorAlotButton = ({
  id,
  handleVendorUpdate,
  end_date,
  start_date,
  package_type,
  latest_va_id,
  vendorAllotAction,
}) => {
  return (
    <>
      <div className="flex justify-end text-right ">
        <Button
          onClick={() =>
            handleVendorUpdate(
              id,
              start_date,
              end_date,
              package_type,
              latest_va_id,
              vendorAllotAction,
            )
          }
          className="p-2 cursor-pointer text-white-400 hover:bg-green focus:outline-none"
        >
          Allot
        </Button>
      </div>
    </>
  );
};

export default VendorAlotButton;
